/**
 * Hook: useTenants
 * Busca a lista de tenants (representações) do banco de dados
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Tenant {
  id: number;
  nome: string;
}

export function useTenants() {
  return useQuery({
    queryKey: ['tenants'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('tenants')
        .select('id, nome')
        .eq('status', 'ATIVO')
        .order('nome', { ascending: true });

      if (error) {
        throw new Error(`Erro ao buscar tenants: ${error.message}`);
      }

      return (data as Tenant[]) || [];
    },
    staleTime: 1000 * 60 * 10, // 10 minutos
    retry: 2
  });
}
